import * as Yup from "yup";

export type SignUpFormInputs = {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  password_again: string;
};

export const initialValues: SignUpFormInputs = {
  first_name: "",
  last_name: "",
  email: "",
  password: "",
  password_again: "",
};

export const validationSchema = Yup.object({
  first_name: Yup.string().required("First Name is required."),
  last_name: Yup.string().required("Last Name is required."),
  email: Yup.string().email("Invalid email format.").required("Email Address is required."),
  password: Yup.string().required("Password is required."),
  password_again: Yup.string().required("Repeat password is required."),
});

export const getPasswordErrors = (pwd: string, pwdAgain: string) => {
  const errors: string[] = [];

  if (pwd.length < 8) {
    errors.push("The password is less than 8 characters.");
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(pwd)) {
    errors.push("The password doesn't have special characters.");
  }
  if (!/\d/.test(pwd)) {
    errors.push("The password doesn't have any numbers.");
  }
  if (!/[A-Z]/.test(pwd)) {
    errors.push("The password doesn't have a capital letter.");
  }

  if ((pwd.length > 0 || pwdAgain.length > 0) && pwd !== pwdAgain) {
    errors.push("The passwords don't match.");
  }

  return errors;
};
